import React, { useState } from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import websitelogo from '../../../../assets/logos/websitelogo.svg';
import websiteloader from '../../../../assets/logos/sidebarHalfLogoPng.png';
import MailOutlineOutlinedIcon from '@mui/icons-material/MailOutlineOutlined';
import CallIcon from '@mui/icons-material/Call';
import ChatIcon from '@mui/icons-material/Chat';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import { login } from '../../../services/api/apiManager';
import './login.css';
// import { useSnackbar } from "notistack";
import { useDispatch } from 'react-redux';
import {
	LOGIN_REQUEST,
	LOGIN_SUCCESS,
	LOGIN_FAILURE,
} from '../../../services/authService/accountActions';
import { actions } from '../../../services/state/Reducer';
import authService from '../../../services/authService/authService';

import {
	Alert,
	Box,
	Checkbox,
	CssBaseline,
	FormControlLabel,
	Grid,
	IconButton,
	InputAdornment,
	OutlinedInput,
	Snackbar,
	TextField,
	Typography,
} from '@mui/material';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { useNavigate, Link } from 'react-router-dom';
import { useStateValue } from '../../../services/state/State';
// const { enqueueSnackbar } = useSnackbar();

function Login() {
	const [{ user }, dispatch] = useStateValue();
	const defaultTheme = createTheme();
	const [openSnackbarError, setOpenSnackbarError] = useState(false);
	const [openSnackbarEmpty, setOpenSnackbarEmpty] = useState(false);
	const [openSnackbarError_, setOpenSnackbarError_] = useState(false);
	// const [showIncorrectPasscode, setShowIncorrectPasscode] = useState(false);
	const lcemail = localStorage.getItem('rememail');
	const lcpass = localStorage.getItem('rempass');
	const check = localStorage.remcheck;
	const [email, setEmail] = useState(lcemail || '');
	const [password, setPassword] = useState(lcpass || '');
	const [loading, setLoading] = useState(false);

	const navigate = useNavigate();

	const handleSignupClick = () => {
		// Navigate to the signup page
		navigate('/signup');
	};
	// const handleCheckboxChange = (event) => {
	// 	setShowIncorrectPasscode(false);
	// };

	const handleSnackbarClose = (event, reason) => {
		if (reason === 'clickaway') {
			return;
		}
		setOpenSnackbarError(false);
		setOpenSnackbarError_(false);
		setOpenSnackbarEmpty(false);
	};
	const onSubmit = async () => {
		setLoading(true);

		try {
			debugger;

			if (!email || !password) {
				setOpenSnackbarEmpty(true);
				return;
			}
			const model = {
				email: email,
				password: password,
			};
			const res = await login(model);
			if (res?.status === 200) {
				const loggedInUser = {
					...res.data,
					userDetail: res.data || null,
					token: res.data.access_token || '',
				};
				//   authService.setUser(loggedInUser);
				authService.setrefreshToken(res?.data?.refresh_token);
				authService.setaccessToken(res?.data?.access_token);
				localStorage.setItem('userName', res?.data?.full_name);
				dispatch({ type: actions.SET_USER, payload: loggedInUser });
				navigate('/selectPractice');
				authService.setSession(res.data.access_token, navigate);
			} else if (
				res?.response?.data?.msg ==
				'Error in LoginUser post: Invalid credentials, Try Again Please'
			) {
				setOpenSnackbarError(true);
			} else {
				setOpenSnackbarError_(true);
			}
		} catch (error) {
			setOpenSnackbarError_(true);
		}
		setLoading(false);
	};

	const handleKeyDown = (e) => {
		if (e.key === 'Enter') {
			onSubmit();
		}
	};
	const RememberData = (checked) => {
		debugger;
		if (checked) {
			localStorage.removeItem('rememail');
			localStorage.setItem('rememail', email);
			localStorage.removeItem('rempass');
			localStorage.setItem('rempass', password);
			localStorage.removeItem('remcheck');
			localStorage.setItem('remcheck', checked);
		} else {
			localStorage.removeItem('remcheck');
			localStorage.removeItem('rempass');
			localStorage.removeItem('rememail');
		}
	};
	const [showPassword, setShowPassword] = React.useState(false);
	const handleClickShowPassword = () => setShowPassword((show) => !show);
	const handleMouseDownPassword = (event) => {
		event.preventDefault();
	};

	return (
		<ThemeProvider theme={defaultTheme}>
			<Grid
				container
				component="main"
				sx={{
					height: '100vh',
					backgroundImage: `url(${require('../../../../assets/images/background.png')})`,
					backgroundRepeat: 'no-repeat',
					backgroundSize: 'cover',
					backgroundPosition: 'center',
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					padding: '10px 50px',
					'@media (max-width: 600px)': {
						// Styles for xs and sm screens
						padding: '50px 30px',
					},
				}}
			>
				<CssBaseline />
				<Grid container item justifyContent="center">
					<Grid
						item
						xs={false}
						sm={6}
						md={4.5}
						lg={4.5}
						xl={3.5}
						sx={{
							backgroundImage: `url(${require('../../../../assets/images/singupbacground.png')})`,
							backgroundRepeat: 'no-repeat',
							backgroundPosition: 'center',
							backgroundSize: 'cover',
							display: 'flex',
							flexDirection: 'column',
							borderRadius: '15px 0px 0px 15px',
							justifyContent: 'space-between',
							// background: '#197CCC',
							display: { sm: 'none', xs: 'none', md: 'flex', xl: 'flex' },
						}}
					>
						<Grid
							item
							sx={{
								display: 'flex',
								flex: '1',
								flexDirection: 'column',
								alignItems: 'center',
								justifyContent: 'center',
							}}
						>
							<Typography
								variant="h5"
								className="slide-in"
								sx={{
									color: 'white',
									fontSize: '23px',
									fontFamily: 'Poppins',
									textAlign: 'center',
								}}
							>
								WELCOME TO MAXCHARTS !
							</Typography>
							<Typography
								variant="h5"
								className="slide-in"
								sx={{
									color: 'white',
									fontSize: '18px',
									fontFamily: 'Poppins',
									textAlign: 'center',
									fontWeight: '400',
								}}
							>
								Connecting Doctors, Patients, and <br /> Billing in Harmony
							</Typography>
						</Grid>
						<Grid
							item
							sx={{
								display: 'flex',
								justifyContent: 'space-evenly',
								borderTop: '0.5px solid rgba(255, 255, 255, 0.40)',
								padding: '15px 50px',
							}}
						>
							<Grid
								container
								alignItems="center"
								justifyContent="center"
								spacing={1} // Adjust the spacing as needed
							>
								<Grid item>
									<ContactSupportIcon sx={{ color: 'white' }} />
								</Grid>
								<Grid item>
									<Link to={'/aboutUs'}>
										<Typography
											variant="body1"
											sx={{
												fontSize: '13px',
												color: 'white',
												fontWeight: '700',
												textDecoration: 'underline',
											}}
										>
											About Us
										</Typography>
									</Link>
								</Grid>
							</Grid>

							<Grid
								container
								alignItems="center"
								justifyContent="center"
								spacing={1} // Adjust the spacing as needed
							>
								<Grid item>
									<CallIcon sx={{ color: 'white' }} />
								</Grid>
								<Grid item>
									<Link to={'/contactUs'}>
										<Typography
											variant="body1"
											sx={{
												fontSize: '13px',
												color: 'white',
												fontWeight: '700',
												textDecoration: 'underline',
											}}
										>
											Contact Us
										</Typography>
									</Link>
								</Grid>
							</Grid>
							{/* <Grid
								container
								alignItems="center"
								justifyContent="center"
								spacing={1} // Adjust the spacing as needed
							>
								<Grid item>
									<ChatIcon sx={{ color: 'white' }} />
								</Grid>
								<Grid item>
									<Link to={'/feedback'}>
										<Typography
											variant="body1"
											sx={{
												fontSize: '13px',
												color: 'white',
												fontWeight: '700',
												textDecoration: 'underline',
											}}
										>
											Feedback
										</Typography>
									</Link>
								</Grid>
							</Grid> */}
						</Grid>
					</Grid>
					<Grid
						component={Paper}
						elevation={6}
						square
						item
						xs={10}
						sm={7}
						md={4.5}
						lg={4.5}
						xl={3.5}
						sx={{
							backgroundImage: `url(${require('../../../../assets/images/formbackground.png')})`,
							backgroundRepeat: 'no-repeat',
							backgroundSize: 'cover',
							backgroundPosition: 'center',
							borderRadius: '0px 15px 15px 0px',
							padding: '30px 20px',
							'@media (max-width: 600px)': {
								// Styles for xs and sm screens
								borderRadius: '15px',
							},
							'@media (max-width: 900px)': {
								// Styles for xs and sm screens
								borderRadius: '15px',
								justifyContent: 'center',
							},
						}}
					>
						{loading ? (
							<div
								style={{
									height: '50vh',
									display: 'flex',
									justifyContent: 'center',
									alignItems: 'center',
								}}
							>
								<div className="logo-container" style={{ width: '30%' }}>
									<img className="logo" src={websitelogo} alt="Website Logo" />
								</div>
							</div>
						) : (
							<Box
								sx={{
									// margin: '10px 30px',
									display: 'flex',
									flexDirection: 'column',
									// alignItems: 'center',
									// justifyContent: 'flex-start',
								}}
							>
								<img
									src={websitelogo}
									alt="Your Alt Text"
									style={{
										maxWidth: '200px',
										height: 'auto',
										objectFit: 'contain',
									}}
								/>
								<Typography
									component="h1"
									variant="h5"
									sx={{
										alignSelf: 'start',
										fontSize: '22px',
										fontWeight: '600',
										mt: '10px',
									}}
								>
									Login In
								</Typography>
								<Box
									component="FORM"
									sx={{
										mt: 1,
									}}
								>
									<Typography
										variant="body2"
										sx={{ color: '#7E7D7D', fontSize: '15px' }}
									>
										Email Address
									</Typography>
									<OutlinedInput
										size="small"
										fullWidth
										type="email"
										name="email"
										value={email}
										onChange={(e) => setEmail(e.target.value)}
										autoComplete="email"
										required
										endAdornment={
											<InputAdornment position="end">
												<MailOutlineOutlinedIcon sx={{ color: '#DDE6F1' }} />
											</InputAdornment>
										}
										sx={{
											marginBottom: '10px',
											// marginTop: '10px',
											// height: '45px',
											// // padding: '5px',
											// '& .MuiOutlinedInput-input': {
											// 	padding: '9px 0px 9px 6px',
											// 	backgroundColor: 'white',
											// },
										}}
									/>
									<Typography
										variant="body2"
										sx={{ color: '#7E7D7D', fontSize: '15px' }}
									>
										Password
									</Typography>
									<OutlinedInput
										size="small"
										fullWidth
										required
										name="password"
										autoComplete="off"
										value={password}
										onChange={(e) => setPassword(e.target.value)}
										onKeyDown={(e) => handleKeyDown(e)}
										type={showPassword ? 'text' : 'password'}
										endAdornment={
											<InputAdornment position="end">
												<IconButton
													aria-label="toggle password visibility"
													onClick={handleClickShowPassword}
													onMouseDown={handleMouseDownPassword}
													edge="end"
													sx={{ color: '#DDE6F1' }}
												>
													{showPassword ? <VisibilityOff /> : <Visibility />}
												</IconButton>
											</InputAdornment>
										}
										sx={{
											marginBottom: '10px',
											// marginTop: '10px',
											// height: '45px',
											// '& .MuiOutlinedInput-input': {
											// 	padding: '9px 0px 9px 6px',
											// },
										}}
									/>
									<Grid container sx={{ alignItems: 'center' }}>
										<Grid item xs>
											<FormControlLabel
												control={
													<Checkbox
														sx={{ fontSize: '13px' }}
														defaultChecked={check}
														color="primary"
														onChange={(e) => RememberData(e.target.checked)}
													/>
												}
												label="Remember me"
											/>
										</Grid>
										<Grid item>
											<Link to="/forgotpassword">
												<Typography variant="body2" fontSize={'13px'}>
													Forgot Password?
												</Typography>
											</Link>
										</Grid>
									</Grid>
									<Button
										variant="contained"
										fullWidth
										size="small"
										sx={{
											background: ' #e87511',
											borderRadius: '8px',
											// height: '40px',
											fontFamily: 'Poppins',
											fontSize: '18px',
											fontWeight: '400',
											marginTop: '10px',
											marginBottom: '15px',
											'&:hover': {
												background: '#e87511',
											},
										}}
										disabled={!email || !password}
										onClick={() => onSubmit()}
									>
										SIGN IN
									</Button>

									<Grid
										container
										spacing={2}
										sx={{
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'flex-end',
											textAlign: 'center',
											paddingTop: '0px',
										}}
									>
										<Grid
											item
											display={'flex'}
											alignItems={'center'}
											flexDirection={'row'}
											justifyContent={'space-between'}
											gap={'6px'}
										>
											<Typography
												variant="body1"
												sx={{
													fontFamily: 'Poppins',
													color: '#7E7D7D',
													fontSize: '15px',
												}}
											>
												Don&apos;t have an account?
											</Typography>
											<Link to={'/signup'}>
												<Typography
													variant="body1"
													sx={{
														fontFamily: 'Poppins',
														// color: 'black',
														fontSize: '15px',
														// display:'flex',
														// justifyContent:'flex-end'
													}}
												>
													{'Signup >'}
												</Typography>
											</Link>
										</Grid>
									</Grid>
									{/* 
	<Button
		variant="outlined"
		fullWidth
		sx={{
			color: ' #e87511', // Text color
			borderColor: ' #e87511', // Border color
			borderRadius: '6px',
			height: '40px',
			fontSize: '25px',
			fontFamily: 'Poppins',
			fontWeight: '400',
			marginTop: '15px',
			border: ' 2px solid #E87511',
			'&:hover': {
				borderColor: '#e87511',
			},
		}}
		onClick={handleSignupClick}
	>
		SIGN UP
	</Button> */}
								</Box>
							</Box>
						)}
					</Grid>
				</Grid>

				{/* snackbars  */}

				<Snackbar
					open={openSnackbarError}
					autoHideDuration={2000}
					onClose={handleSnackbarClose}
					anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
				>
					<Alert
						onClose={handleSnackbarClose}
						severity="error"
						sx={{
							backgroundColor: '#ED2828',
							color: '#FFF',
							fontSize: '15px',
							padding: '15px',
						}}
					>
						Invalid Credentials, Please Try again !
					</Alert>
				</Snackbar>
				<Snackbar
					open={openSnackbarEmpty}
					autoHideDuration={2000}
					onClose={handleSnackbarClose}
					anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
				>
					<Alert
						onClose={handleSnackbarClose}
						severity="error"
						sx={{
							backgroundColor: '#ED2828',
							color: '#FFF',
							fontSize: '15px',
							padding: '15px',
						}}
					>
						Fill in all fields
					</Alert>
				</Snackbar>
				<Snackbar
					open={openSnackbarError_}
					autoHideDuration={3000}
					onClose={handleSnackbarClose}
					anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
				>
					<Alert
						onClose={handleSnackbarClose}
						severity="error"
						sx={{
							backgroundColor: '#ED2828',
							color: '#FFF',
							fontSize: '15px',
							padding: '15px',
						}}
					>
						Something Went Wrong!
					</Alert>
				</Snackbar>
			</Grid>
		</ThemeProvider>
	);
}

export default Login;
